import React, { useMemo } from 'react';
import {
  IFunnelModeSliceFieldsFragment,
  IFunnelStepBriefInfoFieldsFragment,
  IUserAliasReplacementFieldsFragment,
} from '../../utils/apollo/graphqlSchema';
import { getAliasedName } from '../../utils/redux/applyAliasReplacements';
import { parseAliasReplacements } from '../../utils/redux/util';
import { SingleSelectMenu } from '../Dropdown';

interface IProps {
  steps: IFunnelStepBriefInfoFieldsFragment[];
  modeSlices: IFunnelModeSliceFieldsFragment[];
  selectedStep: string | null;
  onChange: (stepIndex: string) => void;
  aliasReplacements: IUserAliasReplacementFieldsFragment[];
  placeholder?: string;
}

const FunnelModeSliceMenu = ({
  steps,
  modeSlices,
  selectedStep,
  onChange,
  aliasReplacements,
  placeholder,
}: IProps) => {
  const options = useMemo(
    () =>
      modeSlices.map((slice, index) => {
        const selectedStepNames = steps
          .filter((_, stepIndex) => slice.measureSelection[stepIndex])
          .map((step) => {
            const aliasId = step.userAlias?.aliasId ?? null;

            const effectiveAliasReplacements =
              parseAliasReplacements(aliasReplacements);
            return getAliasedName(
              step.name,
              aliasId,
              effectiveAliasReplacements,
            ).name;
          });

        const text = selectedStepNames.join(' → ');

        return {
          text,
          title: text,
          value: index.toString(),
        };
      }),
    [modeSlices, steps, aliasReplacements],
  );

  return (
    <SingleSelectMenu
      options={options}
      value={selectedStep}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default FunnelModeSliceMenu;
